import { ContentMapApi } from 'shared/api/requests/contentMap'
import { createAsyncAction } from 'shared/lib/redux'

// Async actions for API calls
export const fetchTargetUserFields = createAsyncAction(
  'mapping/fetchTargetUserFields',
  async (pageId: string) => {
    const { data } = await ContentMapApi.fetchUserFields({
      path: { pageId },
      query: { active_only: true },
    })
    return data.fields
  },
)

export const fetchTargetGlobalFields = createAsyncAction(
  'mapping/fetchTargetGlobalFields',
  async (pageId: string) => {
    const { data } = await ContentMapApi.fetchGlobalFields({
      path: { pageId },
      query: { active_only: true },
    })
    return data.fields
  },
)

export const fetchTargetPageOtns = createAsyncAction(
  'mapping/fetchTargetPageOtns',
  async (pageId: string) => {
    const { data } = await ContentMapApi.fetchOtnReasons({
      path: { pageId },
      query: { active_only: true },
    })
    return data.reasons
  },
)

export const fetchTargetPageTags = createAsyncAction(
  'mapping/fetchTargetPageTags',
  async (pageId: string) => {
    const { data } = await ContentMapApi.fetchPageTags({
      path: { pageId },
      query: { type: 'user' },
    })
    return data.tags
  },
)

export const fetchTargetPageCustomEvents = createAsyncAction(
  'mapping/fetchTargetPageCustomEvents',
  async (pageId: string) => {
    const { data } = await ContentMapApi.fetchCustomEvents({ path: { pageId } })
    return data.list
  },
)

// Re-export slice actions
export {
  updateOtnsMap,
  updateTagsMap,
  updateCUFsMap,
  updateGAFsMap,
  updateCustomEventsMap,
  resetMaps,
} from './mappingSlice'
